import { memo, type FC, type ReactNode } from "react";

interface CampaignNextButtonProps {
  canProceed: boolean;
  onNext: () => void;
  onBlockedClick: () => void;
  children: ReactNode;
}

const CampaignNextButton: FC<CampaignNextButtonProps> = ({
  canProceed,
  onNext,
  onBlockedClick,
  children,
}) => (
  <button
    type="button"
    className={`button button--primary campaign-flow__action ${
      canProceed ? "" : "button--disabled campaign-flow__action--blocked"
    }`}
    aria-disabled={!canProceed}
    onClick={canProceed ? onNext : onBlockedClick}
  >
    {children}
  </button>
);

export default memo(CampaignNextButton);
